import React, { PropsWithChildren } from 'react';
import { ConfigProvider } from 'antd';
import clsx from 'clsx';
import styles from './ReadOnlyFieldset.module.scss';

interface ReadOnlyFieldsetProps {
  readOnly?: boolean;
  className?: string;
}

/**
 * Renders children with every control inert. Both mechanisms are needed: antd
 * controls are divs the browser won't disable, native ones are invisible to antd.
 */
const ReadOnlyFieldset: React.FC<PropsWithChildren<ReadOnlyFieldsetProps>> = ({ readOnly = false, className, children }) => {
  // Always rendered so the DOM shape doesn't shift between roles.
  const fields = (
    <fieldset disabled={readOnly} className={clsx(styles.readOnlyFieldset, className)}>
      {children}
    </fieldset>
  );

  // `componentDisabled={false}` would force-enable controls an outer provider disabled.
  return readOnly ? <ConfigProvider componentDisabled>{fields}</ConfigProvider> : fields;
};

export default ReadOnlyFieldset;
